import { useState } from 'react';
import copy from 'copy-to-clipboard';
import { SemanticCOLORS } from 'semantic-ui-react/dist/commonjs/generic';

export type InputActionStyle = {
  color?: SemanticCOLORS;
  title: string;
  icon: string;
  onClick: () => void;
};

export default function useCopyToClipboard(
  value?: string,
  canRecopyCallback?: () => void,
  canRecopyTimeout = 2000,
) {
  const [isCopied, setIsCopied] = useState(false);

  function copyToClipboard(text: string) {
    const didCopy = copy(text);
    setIsCopied(didCopy);

    if (didCopy) {
      setTimeout(() => {
        setIsCopied(false);

        if (canRecopyCallback) {
          canRecopyCallback();
        }
      }, canRecopyTimeout);
    }

    return didCopy;
  }

  const copyAction: InputActionStyle = {
    color: isCopied ? ('green' as SemanticCOLORS) : undefined,
    title: isCopied ? 'Copied!' : 'Copy to clipboard',
    icon: isCopied ? 'thumbs up' : 'copy',
    onClick: () => (value !== undefined ? copyToClipboard(value) : undefined),
  };

  return { isCopied, copyToClipboard, copyAction };
}
